<template>
  <section>
    <div id="tab-container">
      <div :class="isActiveClass('all')" @click="categorySelect('all')">
        ALL ABUSE
      </div>
      <div
        :class="isActiveClass('homophobic')"
        @click="categorySelect('homophobic')"
      >
        LGBT
      </div>
    </div>
    <div id="table-head">
      <div
        class="column-header clickable"
        :class="isActive(1)"
        @click="sortToggle(1)"
        id="rank"
      >
        RANK
        <img
          class="order-arrows"
          src="@/assets/images/rank-arrows.png"
          alt="order arrows"
        />
      </div>
      <div
        class="column-header clickable"
        :class="isActive(2)"
        @click="sortToggle(2)"
        id="name"
      >
        NAME
        <img
          class="order-arrows"
          src="@/assets/images/rank-arrows.png"
          alt="order arrows"
        />
      </div>
      <div
        class="column-header clickable"
        :class="isActive(3)"
        @click="sortToggle(3)"
        id="sport"
      >
        SPORT
        <img
          class="order-arrows"
          src="@/assets/images/rank-arrows.png"
          alt="order arrows"
        />
      </div>
      <div class="column-header" id="count">COUNT OF ABUSIVE MESSAGES</div>
    </div>
  </section>
</template>

<script>
export default {
  emits: ["category-change", "sort-change"],
  data() {
    return {
      activeCategory: "all",
      activeColumn: 1,
    };
  },
  methods: {
    categorySelect(category) {
      this.activeCategory = category;
      this.activeColumn = 1;
      this.$emit("category-change", this.activeCategory);
    },
    isActiveClass(tab) {
      if (tab === this.activeCategory) {
        return "active-tab";
      } else {
        return "tab";
      }
    },
    isActive(column) {
      if (column === Math.abs(this.activeColumn)) {
        return "active-column";
      }
    },

    sortToggle(column) {
      if (column === Math.abs(this.activeColumn)) {
        this.activeColumn = -this.activeColumn;
        this.$emit("sort-change", this.activeColumn);
      } else {
        this.activeColumn = column;
        this.$emit("sort-change", this.activeColumn);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div #tab-container {
  color: $blue2;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 80vw;
  max-width: 1320px;

  @include respond(desktop-sm) {
    width: 100%;
    font-size: 14px;
  }
}

div .tab {
  padding: 10px 20px 10px 20px;
  border: 2px $blue2 solid;
  margin: 0px 5px -26px 0px;
  border-radius: 5px 5px 0px 0px;
  width: 180px;
  text-align: center;
  width: 100%;
  max-width: 120px;

  @include respond(desktop-sm) {
    max-width: 90px;
  }

  @include transition(all 0.3s ease-in-out);

  &:hover {
    padding: 10px 20px 30px 20px;
    cursor: pointer;
  }
}

.active-tab {
  color: $white;
  background-color: $blue2;
  border: 2px $blue2 solid;
  margin: 0px 5px 0px 0px;
  padding: 10px 20px 30px 20px;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-weight: bold;
  width: 100%;
  max-width: 120px;
  text-align: center;

  @include transition(all 0.25s ease-out);

  @include respond(desktop-sm) {
    font-size: 14px;
    max-width: 90px;
  }
}

.order-arrows {
  margin: 0px 0px -10px 4px;
  @include respond(desktop-sm) {
    width: 10px;
  }
}

div #table-head {
  height: 90px;
  background-color: $blue2;
  border-radius: 0px 5px 0px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 80vw;
  max-width: 1320px;
  @include respond(desktop-sm) {
    width: 95vw;
    height: 90px;
  }
}

.column-header {
  font-size: 18px;
  width: 90px;
  padding: 10px 10px 15px 2px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 5px;

  @include respond(phone-only) {
    flex-direction: row;
    align-items: flex-start;
  }

  @include transition(all 0.4s ease-in);
}

.clickable {
  &:hover {
    transform: translateY(5px);
    cursor: pointer;
  }
}

.highlight {
  background: black;
}

.active-column {
  text-decoration: underline;
}

#name {
  width: 150px;
   @include respond(phone-only) {
      width:90px;
   }
}
</style>